import SpellDetailCaster from "./SpellDetailCaster";

export default SpellDetailCaster;
export { SpellDetailCaster };
